import React from 'react';
import { Award, Users, Target, Shield } from 'lucide-react';

export const About = () => {
  const features = [
    {
      icon: Award,
      title: 'Trusted Excellence',
      description: '15+ years of delivering exceptional real estate services with proven track record.'
    },
    {
      icon: Users,
      title: 'Customer First',
      description: '1000+ satisfied clients who trust us for their land investment decisions.'
    },
    {
      icon: Target,
      title: 'Strategic Locations',
      description: 'Carefully curated properties in prime locations with high growth potential.'
    },
    {
      icon: Shield,
      title: 'Legal Security',
      description: 'Complete legal verification and documentation for secure transactions.'
    }
  ];

  return (
    <section id="about" className="am-reveal py-20 bg-slate-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4">
              About Acre Mitra
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              Don&rsquo;t wait for the right time.
              <span className="text-emerald-700"> Find the right property.</span>
            </h2>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              India is expanding at a record pace — new metros, greenfield airports, and expressways are re-drawing the map every quarter. Waiting for the &ldquo;perfect&rdquo; moment costs you the corridor. Acre Mitra helps you identify the right plot on the right corridor, backed by legal, geospatial, and ROI due-diligence.
            </p>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Whether it&rsquo;s a residential plot in the Pink Line catchment, a farmhouse near a highway spur, or a warehouse parcel adjacent to a greenfield airport — we handle the verification so you can focus on the decision.
            </p>

            {/* Feature Grid */}
            <div className="grid sm:grid-cols-2 gap-6">
              {features.map((feature) => (
                <div 
                  key={feature.title}
                  className="flex items-start gap-4 p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
                >
                  <div className="flex-shrink-0 w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center">
                    <feature.icon className="text-emerald-700" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 mb-1">{feature.title}</h3>
                    <p className="text-sm text-slate-600">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[16/10] sm:aspect-auto sm:h-[500px]">
              <img
                src="/about/consultant-with-family.jpg"
                alt="Acre Mitra consultant with an Indian family at their new plot"
                loading="lazy"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent pointer-events-none"></div>
              <div className="absolute top-4 left-4 inline-flex items-center gap-1 text-[10px] font-black uppercase tracking-widest text-emerald-100 bg-emerald-900/60 border border-emerald-400/40 px-2 py-1 rounded-full backdrop-blur">
                On-site · With every family
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 sm:w-48 sm:h-48 bg-amber-400 rounded-2xl -z-10"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 sm:w-48 sm:h-48 bg-emerald-700 rounded-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
